import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import Alert from "react-bootstrap/Alert";
import AxisSpinner from "./AxisSpinner";
import UserSelection from "./UserSelection";
import { useLocation, useNavigate } from "react-router-dom";
import { ButtonModalFormSaveClose } from "./ButtonModalSelection";
import { BsPerson, BsExclamationTriangle, BsFileEarmark, BsXCircle } from "react-icons/bs";

const AssignShift = ({ shift, onComplete, makePending, close = null }) => {
  const { authAxios } = useAuth();
  const [loading, setLoading] = useState(false);
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [user, setUser] = useState(null);
  const [needRejectReason, setNeedRejectReason] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [rejectReasonValid, setRejectReasonValid] = useState(false);
  const [needRequestId, setNeedRequestId] = useState(true);
  const [requestIdFieldDisabled, setRequestIdFieldDisabled] = useState(false);
  const [requestId, setRequestId] = useState(null);
  const [requestIdValid, setRequestIdValid] = useState(false);
  const [requestIdRejectReason, setRequestIdRejectReason] = useState(null);
  const [requestIdValidationLoading, setrequestIdValidationLoading] =
    useState(false);
  const [isPending, setPending] = useState(false);
  const [error, setError] = useState(null);
  const [showError, setShowError] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (shift === null && shift === undefined) return;

    setRequestId(shift?.requestId);
    setUser(shift?.user);
  }, [shift]);

  useEffect(() => {
    const valid = validateRequestId();
    const disable =
      valid &&
      shift?.requestId !== "" &&
      shift?.requestId !== null &&
      shift?.requestId !== undefined;
    setRequestIdFieldDisabled(disable);
  }, [requestId]);

  useEffect(() => {
    setPending(makePending);
    setNeedRequestId(!makePending);
  }, [makePending]);

  useEffect(() => {
    var valid =
      rejectReason !== null &&
      rejectReason !== undefined &&
      rejectReason.trim().length > 0;
    setRejectReasonValid(valid);
  }, [rejectReason]);

  useEffect(() => {
    var isReassignShift =
      shift?.user?.id !== null && user?.id !== shift?.user?.id;
    setNeedRejectReason(isReassignShift);

    const valid =
      user?.id !== null &&
      user?.id !== undefined &&
      (needRequestId
        ? requestIdValid === true && requestIdValidationLoading === false
        : true);
    setSaveDisabled(!valid || loading);
  }, [user, requestIdValid, requestIdValidationLoading, loading]);

  const validateRequestId = async () => {
    if (requestId === null || requestId === undefined || requestId === "")
      return;

    setrequestIdValidationLoading(true);
    try {
      var params = {
        request_id: requestId,
      };
      if (shift !== null && shift !== undefined) {
        params["shift_id"] = shift?.id;
        params["shift_table"] = shift?.table;
      }
      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: params,
      };

      const response = await authAxios().post(
        "/api/backoffice/shifts/validate_request_id",
        null,
        config,
      );

      setRequestIdValid(response.data.valid);
      setRequestIdRejectReason(response.data.rejectReason);
      setrequestIdValidationLoading(false);
      return response.data.valid;
    } catch (err) {
      setrequestIdValidationLoading(false);
      console.log("error:");
      console.log(err);
    }
    return false;
  };

  const onSave = async (e) => {
    e.preventDefault();
    
    // Reset error state
    setError(null);
    setShowError(false);
    
    try {
      setLoading(true);

      var needToSetRequestId = shift?.requestId !== requestId && needRequestId;
      if (needToSetRequestId) {
        var params = {
          status: shift?.status,
          shift_id: shift?.id,
        };

        const payload = {
          requestId: requestId,
          startTime: shift?.start,
          endTime: shift?.end,
          priority: shift?.priority,
          skills: shift?.skills,
          trustId: shift?.trust?.id,
          facilityId: shift?.facility?.id,
          wardId: shift?.ward?.id,
          costCentreId: shift?.costCentre?.id,
          grade: shift?.grade,
          gradeType: shift?.gradeType,
          secondaryGrade: shift?.secondaryGrade,
          secondaryGradeType: shift?.secondaryGradeType,
        };

        const config = {
          headers: {
            "content-type": "application/json",
          },
          params: params,
        };

        const response = await authAxios().post(
          "/api/backoffice/shifts/" +
            (shift?.table == "shifts" ? "update" : "archive_update"),
          payload,
          config,
        );
      }

      var isMakePending = isPending;
      var isConfirmShift =
        user?.id == shift?.user?.id && shift?.table === "shifts";
      var isAssignShift =
        shift?.user?.id === null &&
        user?.id !== shift?.user?.id &&
        shift?.table === "shifts";
      var isReassignShift =
        shift?.user?.id !== null &&
        user?.id !== shift?.user?.id &&
        shift?.table === "shifts";
      var isAddArchiveBooking =
        shift?.user?.id === null &&
        user?.id !== shift?.user?.id &&
        shift?.table === "shifts_archived";

      if (isMakePending) {
        const config = {
          headers: {
            "content-type": "application/json",
          },
          params: {
            user_id: user?.id,
            shift_id: shift?.id,
          },
        };
        const response = await authAxios().post(
          "/api/backoffice/shifts/make_pending_active_shift",
          null,
          config,
        );
      } else if (isConfirmShift) {
        const config = {
          headers: {
            "content-type": "application/json",
          },
          params: {
            shift_id: shift?.id,
            request_id: requestId,
          },
        };
        const response = await authAxios().post(
          "/api/backoffice/shifts/confirm_active_shift",
          null,
          config,
        );
      } else if (isAssignShift) {
        const config = {
          headers: {
            "content-type": "application/json",
          },
          params: {
            user_id: user?.id,
            shift_id: shift?.id,
            request_id: requestId,
          },
        };
        const response = await authAxios().post(
          "/api/backoffice/shifts/assign_active_booking",
          null,
          config,
        );
      } else if (isReassignShift) {
        const config = {
          headers: {
            "content-type": "application/json",
          },
          params: {
            user_id: user?.id,
            shift_id: shift?.id,
            request_id: requestId,
            reject_reason: rejectReason,
          },
        };
        const response = await authAxios().post(
          "/api/backoffice/shifts/reassign_active_shift",
          null,
          config,
        );
      } else if (isAddArchiveBooking) {
        const config = {
          headers: {
            "content-type": "application/json",
          },
          params: {
            user_id: user?.id,
            archive_shift_id: shift?.id,
            request_id: requestId,
          },
        };
        const response = await authAxios().post(
          "/api/backoffice/shifts/add_archive_booking",
          null,
          config,
        );
      } else {
        console.log("ERROR unhandled XXXXXXXX");
      }

      const fetchConfig = {
        headers: {
          "content-type": "application/json",
        },
        params: {
          shift_id: shift?.id,
        },
      };

      const shiftResponse = await authAxios().get(
        "/api/backoffice/shifts/" +
          (shift?.table === "shifts" ? "active" : "archive"),
        fetchConfig,
      );

      setLoading(false);
      onComplete(shiftResponse.data);
    } catch (err) {
      setLoading(false);
      
      // Set error message based on the error
      let errorMessage = "Failed to assign shift. Please try again.";
      
      if (err.response) {
        if (err.response.status === 400) {
          errorMessage = "Invalid shift data. Please check all fields and try again.";
        } else if (err.response.status === 401) {
          errorMessage = "Your session has expired. Please log in again.";
        } else if (err.response.status === 403) {
          errorMessage = "You don't have permission to assign this shift.";
        } else if (err.response.status === 404) {
          errorMessage = "The shift or user was not found.";
        } else if (err.response.status === 500) {
          errorMessage = "Server error while processing your request. Please try again later.";
        }
        
        // If we have a more specific error message from the server
        if (err.response.data && err.response.data.message) {
          errorMessage = err.response.data.message;
        }
      }
      
      setError(errorMessage);
      setShowError(true);
      console.error("Error assigning shift:", err);
    }
  };

  const requestIdChanged = (value) => {
    var text = value.target.value;
    setRequestId(text.trim());
  };

  const rejectReasonChanged = (value) => {
    var text = value.target.value;
    setRejectReason(text.trim());
  };

  return (
    <>
      {loading && (
        <div className="overlay-spinner">
          <div className="text-center">
            <AxisSpinner loading={loading} />
            <div className="mt-2 fw-bold text-axis-offblack">Assigning Shift...</div>
          </div>
        </div>
      )}
      
      <Form onSubmit={onSave}>
        {/* Error Alert */}
        {showError && error && (
          <Alert 
            variant="danger" 
            className="mb-4" 
            dismissible 
            onClose={() => setShowError(false)}
          >
            <div className="d-flex align-items-center">
              <BsExclamationTriangle className="me-2" size={20} />
              <div>{error}</div>
            </div>
          </Alert>
        )}
        
        {/* Header with shift info */}
        <div className="mb-4 d-flex justify-content-between align-items-center">
          <h5 className="mb-0 text-axis-offblack">
            {isPending ? "Make Shift Pending" : "Assign Shift"}
          </h5>
          <div className="text-muted small">
            {shift?.facility?.name && <span>Facility: {shift?.facility?.name} | </span>}
            {shift?.ward?.identifier && <span>Ward: {shift?.ward?.identifier}</span>}
          </div>
        </div>
        
        {/* Request ID Section */}
        {needRequestId && (
          <Card className="mb-4 border-0 shadow-sm">
            <Card.Header className="bg-light d-flex align-items-center">
              <BsFileEarmark className="me-2 text-primary" />
              <span className="fw-bold">Request Information</span>
            </Card.Header>
            <Card.Body>
              <Form.Group controlId="formRequestId">
                <Form.Label className="fw-semibold">Request ID {requestIdFieldDisabled ? "" : <span className="text-danger">*</span>}</Form.Label>
                <div className="d-flex align-items-center">
                  <Form.Control
                    type="text"
                    value={requestId}
                    onChange={requestIdChanged}
                    isValid={requestIdValid}
                    isInvalid={!requestIdValid}
                    disabled={requestIdFieldDisabled}
                    required={!requestIdFieldDisabled}
                    className="me-2"
                  />
                  {requestIdValidationLoading && <AxisSpinner loading={requestIdValidationLoading} />}
                </div>
                <Form.Text className="text-muted">
                  Enter the request ID for this shift assignment
                </Form.Text>
                <Form.Control.Feedback type="invalid">
                  {requestIdRejectReason}
                </Form.Control.Feedback>
              </Form.Group>
            </Card.Body>
          </Card>
        )}
        
        {/* User Selection Section */}
        <Card className="mb-4 border-0 shadow-sm">
          <Card.Header className="bg-light d-flex align-items-center">
            <BsPerson className="me-2 text-primary" />
            <span className="fw-bold">User Assignment</span>
          </Card.Header>
          <Card.Body>
            <Form.Group controlId="formUserSelection">
              <Form.Label className="fw-semibold">Select User <span className="text-danger">*</span></Form.Label>
              <UserSelection defaultValue={user} onSelected={setUser} />
              <Form.Text className="text-muted">
                Select the user to assign to this shift
              </Form.Text>
            </Form.Group>
            
            {/* Reject Reason (conditionally shown) */}
            {needRejectReason && (
              <Form.Group className="mt-3" controlId="formRejectReason">
                <Form.Label className="fw-semibold">Rejection Reason <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  onChange={rejectReasonChanged}
                  isValid={rejectReasonValid}
                  isInvalid={!rejectReasonValid}
                  required
                  placeholder={`Enter reason for rejecting ${shift?.user?.forename} ${shift?.user?.surname}`}
                />
                <Form.Text className="text-muted">
                  Provide a reason why the current user is being unassigned
                </Form.Text>
                <Form.Control.Feedback type="invalid">
                  Please provide a rejection reason for {shift?.user?.surname}, {shift?.user?.forename}
                </Form.Control.Feedback>
              </Form.Group>
            )}
          </Card.Body>
        </Card>
        
        {/* Action Buttons */}
        <div className="text-end mt-4">
          <ButtonModalFormSaveClose
            saveName={isPending ? "Make Pending" : "Assign Shift"}
            formSave={onSave}
            close={close}
            loading={saveDisabled || loading}
          />
        </div>
      </Form>
    </>
  );
};

export default AssignShift;
